import React, { useState } from "react";

export default function MediaTile({
  image,
  title,
  description,
  badge,
  id,
  label,
  height
}) {
  
    const [isHovered, setIsHovered] = useState(false);

    const defaultStyle = { 
        backgroundColor: "rgb(var(--bg))", 
        color: "rgb(var(--text))", 
        boxShadow: "4px 4px 12px rgb(var(--shadow))", // X, Y, blur, color
        minHeight : height || "auto",
        maxHeight : height || "auto"
    };

    const hoverStyle = {
        color: "rgb(var(--pink))",
        border: "2px solid rgb(var(--pink))",
        // boxShadow: "4px 4px 12px rgb(var(--pink))", // X, Y, blur, color
    }
  return (
    <div
      className="
        group relative
        h-full
        overflow-hidden
        bg-bg border border-border
        shadow-sm hover:shadow-lg
        transition
      "
    //   style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
      style={isHovered ? { ...defaultStyle, ...hoverStyle } : defaultStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Image */}
      <div className="relative h-[70%] overflow-hidden">
        <img
          src={image}
          alt={title}
          className="
            h-full w-full object-cover
            transition-transform duration-500 ease-out
            group-hover:scale-110
          "
          style={isHovered ? {transition: "transform 0.4s ease",
        transform: "scale(1.2)"} : {}}
        />

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition" />

        {/* Badge */}
        {badge && (
          <div className="absolute top-3 left-3 bg-bg/80 text-text text-xs px-2 py-1 rounded z-10">
            {badge}
          </div>
        )}

        {/* ▶ Play Button (center) */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition z-8">
          <button
            aria-label="Play"
            className="
              rounded-full
              pl-5 pr-4
              pt-2 pb-3
              shadow-lg
              hover:bg-secondary
              transition
            "
            style={{ 
                backgroundColor: "rgb(var(--pink))", 
                color: "rgb(var(--bg))", 
                fontSize: "x-large"
            }}
          >
            ▶
          </button>
        </div>
      </div>

      {/* Bottom Content */}
      <div className="h-[30%] px-2 py-2">
        <span
          className="t-title"
          style={{
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
          }}
          title={title}
        >
          {title}
        </span>
        {label?.length > 0 && 
          <p className="mt-1 t-artist"
          style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
          }}
          title={label}
          >
          Label: {label}
          </p>

        }
        {/* Truncated description + tooltip */}
       <p
        className="mt-1 t-desc"
        style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
        }}
        title={description}
        >
        {description}
        </p>
      </div>
    </div>
  );
}
